import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Button,
  createTheme,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Popper,
  // Image
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { themeOptions, theming } from "../../../theme";
import { ThemeProvider } from "@emotion/react";
import MainModal from "../../MainModal";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import {
  editCourse,
  viewCourseDetails,
} from "../../../redux/actions/courses-action";

const holesHeadRow = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "O",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "I",
  "T",
];

const useStyles = makeStyles((theme) => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& * > input": {
      padding: "5px !important",
    },
    "& * > select": {
      padding: "3.5px !important",
    },
  },
  addIconButton: {
    background: "#2C633C !important",
    height: "30px",
    width: "30px",
  },
  searchBtn: {
    backgroundColor: "#2C633C !important",
    paddingRight: "20px !important",
    paddingLeft: "20px !important",
    height: "40px",
  },
  bottomIconButton: {
    color: "white",
  },
  iconBtn: {
    backgroundColor: "#2C633C !important",
    padding: 0,
    borderRadius: "10px !important",
  },
  addIcon: {
    color: "white",
  },
  inputLabel: {
    fontWeight: "bold !important",
  },
  tabStyle: {
    borderWidth: 1,
    borderColor: "#ccc",
    width: "50%",
    borderRadius: "30px",
    fontWeight: 800,
  },
  tabActiveStyle: {
    width: "200px",
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: "30px !important",
    fontWeight: 800,
    border: "1px solid #ccc",
    background: "white !important",
    color: "#06623B",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0px",
    cursor: "pointer",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
  },
  table: {
    margin: "25px 0 !important",
    overflow: "scroll",
  },
  tableTextField: {
    width: "30px",
    height: "40px",
    textAlign: "center",
  },
  blueTeesBtn: {
    "&:hover": {
      color: "white !important",
      backgroundColor: "grey !important",
    },
  },
  poperBox: {
    backgroundColor: "#D8D8D8 !important",
    borderRadius: "5px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const MapIframeComponent = (props) => {
  const { lat, lng } = props;

  const center = {
    lat: +lat,
    lng: +lng,
  };

  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
      position: { lat: center.lat, lng: center.lng },
      map,
      title: "Hello World!",
    });
    return marker;
  };

  return (
    <div style={{ height: "60vh", width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyD780hsdzAic_x-jjzclaUxf_4BsuKiqV4" }}
        defaultCenter={center}
        defaultZoom={10}
        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
        yesIWantToUseGoogleMapApiInternals={true}
      />
    </div>
  );
};

export default function CourseDetails(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = createTheme(themeOptions);

  const [map, setMap] = useState(null);
  const [course, setCourse] = useState(null);
  const [textParValues, setTextParValues] = useState({ par_value: "" });
  const [tableRows, setTableRows] = useState({
    holes: [],
    blueTees: [],
    yellowTees: [],
    whiteTees: [],
    blackTees: [],
    pars: [],
    indexes: [],
    b_courseRating: "",
    b_slopeRating: "",
    w_courseRating: "",
    w_slopeRating: "",
    y_courseRating: "",
    y_slopeRating: "",
    bk_courseRating: "",
    bk_slopeRating: "",
  });

  const [open, setOpen] = useState(false);

  const [value, setValue] = useState(0);

  const [status, setStatus] = useState("Inactive");
  const [marker, setMarker] = useState({
    lat: null,
    lng: null,
  });

  //# poper region start

  // Blue poper
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const poperOpen = Boolean(anchorEl);
  const poperId = open ? "simple-popper" : undefined;

  // white poper
  const [w_anchorEl, setW_AnchorEl] = useState(null);

  const handleClickW = (event) => {
    setW_AnchorEl(w_anchorEl ? null : event.currentTarget);
  };

  const poperWOpen = Boolean(w_anchorEl);
  const poperWId = open ? "simple-popper" : undefined;

  // yellow poper
  const [y_anchorEl, setY_AnchorEl] = useState(null);

  const handleClickY = (event) => {
    setY_AnchorEl(y_anchorEl ? null : event.currentTarget);
  };

  const poperYOpen = Boolean(y_anchorEl);
  const poperYId = open ? "simple-popper" : undefined;

  // black poper
  const [bk_anchorEl, setBk_AnchorEl] = useState(null);

  const handleClickBk = (event) => {
    setBk_AnchorEl(bk_anchorEl ? null : event.currentTarget);
  };

  const poperBkOpen = Boolean(bk_anchorEl);
  const poperBkId = open ? "simple-popper" : undefined;

  //#  poper region end

  const courseList = useSelector(
    (state) => state.viewCourseReducer?.data?.Course
  );
  const userRole = useSelector((state) => state.userDetailsReducer?.role);

  const lat = courseList?.latitude?.$numberDecimal;
  const lng = courseList?.longitude?.$numberDecimal;

  const initaialSetParValues = () => {
    setTextParValues(course?.tees[0]?.values);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const closeModal = () => {
    setOpen(false);
  };

  const onChangeBlueTextParValue = (e, index) => {
    const { value, name } = e.target;

    if (value.length > 2) {
      return;
    }

    if (!isNaN(value)) {
      var blueTees = tableRows.blueTees;
      tableRows.blueTees[index] = parseInt(value);
      blueTees[index] = value;

      var outSum = 0;
      var inSum = 0;
      blueTees.forEach((v, i) => {
        if (i < 9) {
          outSum += parseInt(v);
        }
        if (i >= 10 && i < 19) {
          inSum += parseInt(v);
        }
      });
      blueTees[9] = outSum;
      blueTees[19] = inSum;
      blueTees[20] = outSum + inSum;
      setTableRows({ ...tableRows, blueTees });
    }
  };

  const onChangeWhiteTextParValue = (e, index) => {
    const { value, name } = e.target;

    if (value.length > 2) {
      return;
    }

    if (!isNaN(value)) {
      var whiteTees = tableRows.whiteTees;
      tableRows.whiteTees[index] = parseInt(value);
      whiteTees[index] = value;

      var outSum = 0;
      var inSum = 0;
      var total = 0;
      var b = 0;
      whiteTees.forEach((v, i) => {
        if (i < 9) {
          outSum += parseInt(v);
        }
        if (i > 9 && i < 19) {
          inSum += parseInt(v);
        }
        total = outSum + inSum;
      });
      whiteTees[9] = outSum;
      whiteTees[19] = inSum;
      whiteTees[20] = total;
      setTableRows({ ...tableRows, whiteTees });
    }
  };

  const onChangeYellowTextParValue = (e, index) => {
    const { value, name } = e.target;

    if (value.length > 2) {
      return;
    }

    if (!isNaN(value)) {
      var yellowTees = tableRows.yellowTees;
      tableRows.yellowTees[index] = parseInt(value);
      yellowTees[index] = value;

      var outSum = 0;
      var inSum = 0;
      var total = 0;
      var b = 0;
      yellowTees.forEach((v, i) => {
        if (i < 9) {
          outSum += parseInt(v);
        }
        if (i > 9 && i < 19) {
          inSum += parseInt(v);
        }
        total = outSum + inSum;
      });
      yellowTees[9] = outSum;
      yellowTees[19] = inSum;
      yellowTees[20] = total;
      setTableRows({ ...tableRows, yellowTees });
    }
  };

  const onChangeBlackTextParValue = (e, index) => {
    const { value, name } = e.target;

    if (value.length > 2) {
      return;
    }

    if (!isNaN(value)) {
      var blackTees = tableRows.blackTees;
      tableRows.blackTees[index] = parseInt(value);
      blackTees[index] = value;

      var outSum = 0;
      var inSum = 0;
      var total = 0;
      blackTees.forEach((v, i) => {
        if (i < 9) {
          outSum += parseInt(v);
        }
        if (i > 9 && i < 19) {
          inSum += parseInt(v);
        }
        total = outSum + inSum;
      });
      blackTees[9] = outSum;
      blackTees[19] = inSum;
      blackTees[20] = total;
      setTableRows({ ...tableRows, blackTees });
    }
  };

  const onChangeIndexesValue = (e, index) => {
    const { value, name } = e.target;
    if (value.length > 2) {
      return;
    }
    if (!isNaN(value)) {
      var indexes = tableRows.indexes;
      tableRows.indexes[index] = parseInt(value);
      indexes[index] = value;

      var outSum = 0;
      var inSum = 0;
      var total = 0;
      var b = 0;
      indexes.forEach((v, i) => {
        if (i < 9) {
          outSum += parseInt(v);
        }
        if (i > 9 && i < 19) {
          inSum += parseInt(v);
        }
        total = outSum + inSum;
      });
      indexes[9] = outSum;
      indexes[19] = inSum;
      indexes[20] = total;
      setTableRows({ ...tableRows, indexes });
    }
  };

  const onChangeTextParValue = (e, index) => {
    const { value, name } = e.target;

    if (value.length > 2) {
      return;
    }
    if (!isNaN(value)) {
      var pars = tableRows.pars;
      tableRows.pars[index] = parseInt(value);
      pars[index] = value;

      var outSum = 0;
      var inSum = 0;
      var total = 0;
      var b = 0;
      pars.forEach((v, i) => {
        if (i < 9) {
          outSum += parseInt(v);
        }
        if (i > 9 && i < 19) {
          inSum += parseInt(v);
        }
        total = outSum + inSum;
      });
      pars[9] = outSum;
      pars[19] = inSum;
      pars[20] = total;
      setTableRows({ ...tableRows, pars });
    }
  };

  const onChangeBlueCourseRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, b_courseRating: value });
  };

  const onChangeBlueSlopeRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, b_slopeRating: value });
  };

  const onChangeWhiteCourseRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, w_courseRating: value });
  };

  const onChangeWhiteSlopeRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, w_slopeRating: value });
  };

  const onChangeYellowCourseRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, y_courseRating: value });
  };

  const onChangeYellowSlopeRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, y_slopeRating: value });
  };

  const onChangeBlackCourseRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, bk_courseRating: value });
  };

  const onChangeBlackSlopeRating = (e) => {
    const { value } = e.target;
    setTableRows({ ...tableRows, bk_slopeRating: value });
  };

  const onSubmit = () => {
    tableRows.blueTees.splice(9, 1);
    tableRows.blueTees.splice(18, 2);

    tableRows.whiteTees.splice(9, 1);
    tableRows.whiteTees.splice(18, 2);

    tableRows.yellowTees.splice(9, 1);
    tableRows.yellowTees.splice(18, 2);

    tableRows.blackTees.splice(9, 1);
    tableRows.blackTees.splice(18, 2);

    tableRows.indexes.splice(9, 1);
    tableRows.indexes.splice(18, 2);

    tableRows.pars.splice(9, 1);
    tableRows.pars.splice(18, 2);

    var x = tableRows.blueTees.map((item, i) => {
      return {
        hole_no: i + 1,
        par_value: item,
      };
    });

    var y = tableRows.whiteTees.map((item, i) => {
      return {
        hole_no: i + 1,
        par_value: item,
      };
    });

    var z = tableRows.yellowTees.map((item, i) => {
      return {
        hole_no: i + 1,
        par_value: item,
      };
    });

    var bk = tableRows.blackTees.map((item, i) => {
      return {
        hole_no: i + 1,
        par_value: item,
      };
    });

    var parsValues = tableRows.pars.map((item, i) => {
      return {
        hole_no: i + 1,
        pars: item,
      };
    });
    var indexValues = tableRows.indexes.map((item, i) => {
      return {
        index: item,
        par: parsValues[i].pars,
        hole_no: parsValues[i].hole_no,
      };
    });

    var dataObj = {
      city_id: courseList?.city_id,
      address: courseList?.address,
      course_rating: courseList?.course_rating,
      course_combination: courseList?.course_combination,
      latitude: courseList?.latitude,
      longitude: courseList?.longitude,
      slope_rating: courseList?.slope_rating,
      status: courseList?.status,
      course_holes: indexValues,
      tees: [
        {
          name: "Blue",
          color: "blue",
          course_rating: tableRows.b_courseRating,
          slope_rating: tableRows.b_slopeRating,
          values: x,
        },
        {
          name: "White",
          color: "white",
          course_rating: tableRows.w_courseRating,
          slope_rating: tableRows.w_slopeRating,
          values: y,
        },
        {
          name: "Yellow",
          color: "yellow",
          course_rating: tableRows.y_courseRating,
          slope_rating: tableRows.y_slopeRating,
          values: z,
        },
        {
          name: "Black",
          color: "black",
          course_rating: tableRows.bk_courseRating,
          slope_rating: tableRows.bk_slopeRating,
          values: bk,
        },
      ],
    };
    dispatch(editCourse(id, dataObj, navigate));
  };

  useEffect(() => {
    if (courseList?.tees.length >= 0) {
      var l_TableRows = [tableRows].reduce((r) => r != null);
      if (courseList?.tees.length > 0) {
        var BlueCourseTees = courseList?.tees
          ?.filter((t) => t.name === "Blue")
          .reduce((r) => r != null);
      }
      if (courseList?.tees.length > 0) {
        var YellowCourseTees = courseList?.tees
          ?.filter((t) => t.name === "Yellow")
          .reduce((r) => r != null);
      }
      if (courseList?.tees.length > 0) {
        var WhiteCourseTees = courseList?.tees
          ?.filter((t) => t.name === "White")
          .reduce((r) => r != null);
      }
      if (courseList?.tees.length > 0) {
        var BlackCourseTees = courseList?.tees
          ?.filter((t) => t.name === "Black" || t.color === "black")
          .reduce((r) => r != null);
      }

      var i_courseHoles = courseList?.course_holes;
      var p_courseHoles = courseList?.course_holes;

      // Course holes

      let index_out_sum = 0;
      let index_in_sum = 0;
      i_courseHoles?.map((item, i) => {
        l_TableRows.indexes[item?.hole_no - 1] = item?.index;
        if (i <= 9) {
          index_out_sum += item?.index;
        }
        if (i > 10 && i < 19) {
          index_in_sum += item?.index;
        }
      });

      let par_out_sum = 0;
      let par_in_sum = 0;
      p_courseHoles?.map((item, i) => {
        l_TableRows.pars[item?.hole_no - 1] = item?.par;
        if (i <= 9) {
          par_out_sum += item?.index;
        }
        if (i > 10 && i < 19) {
          par_in_sum += item?.index;
        }
      });

      // Blue tees
      let b_outSum = 0;
      let b_inSum = 0;

      BlueCourseTees?.values.map((tee, index) => {
        if (index <= 9) {
          b_outSum += tee?.par_value;
        }
        if (index > 10 && index < 19) {
          b_inSum += tee?.par_value;
        }

        l_TableRows.blueTees[tee?.hole_no - 1] = tee?.par_value;
      });

      l_TableRows.blueTees.splice(9, 0, b_outSum);
      l_TableRows.blueTees.splice(19, 0, b_inSum);
      l_TableRows.blueTees.splice(20, 0, b_outSum + b_inSum);
      l_TableRows.b_courseRating =
        BlueCourseTees?.course_rating?.$numberDecimal;
      l_TableRows.b_slopeRating = BlueCourseTees?.slope_rating?.$numberDecimal;
      l_TableRows.indexes.splice(9, 0, index_out_sum);
      l_TableRows.indexes.splice(19, 0, index_in_sum);
      l_TableRows.indexes.splice(20, 0, index_out_sum + index_in_sum);
      l_TableRows.pars.splice(9, 0, par_out_sum);
      l_TableRows.pars.splice(19, 0, par_in_sum);
      l_TableRows.pars.splice(20, 0, par_out_sum + par_in_sum);

      // white tess
      let w_outSum = 0;
      let w_inSum = 0;

      WhiteCourseTees?.values.map((tee, index) => {
        if (index <= 9) {
          w_outSum += tee?.par_value;
        }
        if (index > 10 && index < 19) {
          w_inSum += tee?.par_value;
        }

        l_TableRows.whiteTees[tee?.hole_no - 1] = tee?.par_value;
      });

      l_TableRows.whiteTees.splice(9, 0, w_outSum);
      l_TableRows.whiteTees.splice(19, 0, w_inSum);
      l_TableRows.whiteTees.splice(20, 0, w_outSum + w_inSum);
      l_TableRows.w_courseRating =
        WhiteCourseTees?.course_rating?.$numberDecimal;
      l_TableRows.w_slopeRating = WhiteCourseTees?.slope_rating?.$numberDecimal;

      // Yellow tess
      let y_outSum = 0;
      let y_inSum = 0;

      YellowCourseTees?.values.map((tee, index) => {
        if (index <= 9) {
          y_outSum += tee?.par_value;
        }
        if (index > 10 && index < 19) {
          y_inSum += tee?.par_value;
        }

        l_TableRows.yellowTees[tee?.hole_no - 1] = tee?.par_value;
      });
      l_TableRows.yellowTees.splice(9, 0, y_outSum);
      l_TableRows.yellowTees.splice(19, 0, y_inSum);
      l_TableRows.yellowTees.splice(20, 0, y_outSum + y_inSum);
      l_TableRows.y_courseRating =
        YellowCourseTees?.course_rating?.$numberDecimal;
      l_TableRows.y_slopeRating =
        YellowCourseTees?.slope_rating?.$numberDecimal;

      // Black tees
      let bk_outSum = 0;
      let bk_inSum = 0;

      BlackCourseTees?.values.map((tee, index) => {
        if (index <= 9) {
          bk_outSum += tee?.par_value;
        }
        if (index > 10 && index < 19) {
          bk_inSum += tee?.par_value;
        }

        l_TableRows.blackTees[tee?.hole_no - 1] = tee?.par_value;
      });
      l_TableRows.blackTees.splice(9, 0, bk_outSum);
      l_TableRows.blackTees.splice(19, 0, bk_inSum);
      l_TableRows.blackTees.splice(20, 0, bk_outSum + bk_inSum);
      l_TableRows.bk_courseRating =
        BlackCourseTees?.course_rating?.$numberDecimal;
      l_TableRows.bk_slopeRating =
        BlackCourseTees?.slope_rating?.$numberDecimal;
      // }
    }
  }, [courseList]);

  useEffect(() => {
    if (courseList !== undefined) {
      setMarker({
        lat: +courseList?.latitude?.$numberDecimal,
        lng: +courseList?.longitude?.$numberDecimal,
      });
    }

    return () => {
      setMarker({
        lat: null,
        lng: null,
      });
    };
  }, [courseList]);

  useEffect(() => {
    dispatch(viewCourseDetails(id));

    let cellsArr = [];
    let cellsArr2 = [];

    for (var i = 1; i <= 21; i++) {
      cellsArr.push(0);
    }

    setTableRows({
      ...tableRows,
      holes: [...cellsArr],

      blueTees: [...cellsArr],
      whiteTees: [...cellsArr],
      yellowTees: [...cellsArr],
      pars: [...cellsArr],
      indexes: [...cellsArr],
    });
  }, []);

  useEffect(() => {
    if (course) initaialSetParValues();
  }, [course]);

  return (
    <ThemeProvider theme={theme}>
      {/* { parent-container} */}
      <Grid container>
        <Grid item xs={12} p={3}>
          {/* {container} */}
          <Grid item container display={"flex"} justifyContent={"flex-end"}>
            <Grid item xs={12}>
              <Typography>{course?.address}</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
              mt={2}
            >
              <Stack direction="row" spacing={1}></Stack>
            </Grid>
          </Grid>

          <Grid container mt={3}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ display: value == 1 ? "block" : "none" }}
                variant="contained"
                onClick={onSubmit}
              >
                Save
              </Button>
            </Grid>
          </Grid>

          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                border: 1,
                border: 1,
                padding: 2,
                borderRadius: 1,
                boxShadow: 3,
                borderColor: "#F2F2F2",
                marginTop: "25px",
              }}
            >
              <Box
                sx={{
                  borderBottom: 0,
                  borderColor: "divider",
                }}
              >
                {userRole === "admin" || userRole === "super" ? (
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    TabIndicatorProps={{
                      style: {
                        display: "none",
                      },
                    }}
                    sx={{
                      width: "400px",
                      backgroundColor: "#D2D2D2 !important",
                      borderRadius: "25px",
                      overflow: "hidden",
                      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                      border: "none",
                    }}
                  >
                    <Tab
                      label="MAP"
                      {...a11yProps(0)}
                      className={`${classes.tabStyle} ${
                        value === 0 && classes.tabActiveStyle
                      }`}
                    />
                    <Tab
                      label="Scorecard"
                      {...a11yProps(1)}
                      className={`${classes.tabStyle} ${
                        value === 1 && classes.tabActiveStyle
                      }`}
                    />
                  </Tabs>
                ) : (
                  <Box
                    sx={{
                      width: "200px",
                      borderWidth: 1,
                      borderColor: "#ccc",
                      borderRadius: "30px",
                      fontWeight: 800,
                      border: "1px solid #ccc",
                      background: "white",
                      color: "#06623B",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px 0px",
                      cursor: "pointer",
                      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                    }}
                  >
                    MAP
                  </Box>
                )}
              </Box>

              <TabPanel
                style={{
                  overflow: "hidden",
                  overflowY: "auto",
                  overflowX: "auto",
                }}
                value={value}
                index={0}
              >
                {marker.lat !== null && marker.lng !== null && (
                  <MapIframeComponent lat={marker.lat} lng={marker.lng} />
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Grid
                  style={{
                    overflow: "hidden",
                    overflowY: "auto",
                    overflowX: "auto",
                  }}
                  container
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      border: 1,
                      border: 1,
                      padding: 2,
                      borderRadius: 1,
                      boxShadow: 3,
                      borderColor: "#F2F2F2",
                    }}
                  >
                    <Typography>Tees List</Typography>
                    <Grid item container>
                      <Grid item xs={12}>
                        <TableContainer>
                          <Table aria-label="table" className={classes.table}>
                            <TableHead>
                              <TableRow className={classes.tableRow}>
                                <TableCell>Tees</TableCell>
                                {holesHeadRow.map((item, index) =>
                                  item == "O" ? (
                                    <TableCell>Out</TableCell>
                                  ) : item == "I" ? (
                                    <TableCell>In</TableCell>
                                  ) : item == "T" ? (
                                    <TableCell>Total</TableCell>
                                  ) : (
                                    <TableCell align="center">{item}</TableCell>
                                  )
                                )}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  <Button
                                    aria-describedby={poperId}
                                    type="button"
                                    onClick={handleClick}
                                    sx={{
                                      backgroundColor: "blue",
                                      color: "white",
                                    }}
                                    className={classes.blueTeesBtn}
                                  >
                                    Blue
                                  </Button>
                                  <Popper
                                    id={poperId}
                                    open={poperOpen}
                                    anchorEl={anchorEl}
                                    sx={{
                                      borderRadius: "5px",
                                      border:
                                        "2px sollid rgba(0 0 0,0.4) !important",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        padding: "14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          // fontSize={10}
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "8px !important",
                                          }}
                                        >
                                          Course Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "5px 5px 5px 4px !important",
                                          }}
                                          onChange={onChangeBlueCourseRating}
                                          value={tableRows.b_courseRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        padding:
                                          "1px 14px 14px 14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          // fontSize={10}
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "5px !important",
                                          }}
                                        >
                                          Slope Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "8px 0px 0px 16px !important",
                                          }}
                                          onChange={onChangeBlueSlopeRating}
                                          value={tableRows.b_slopeRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                  </Popper>
                                </TableCell>
                                {tableRows.holes.map((item, i) => {
                                  return (
                                    <TableCell align="center">
                                      {i !== 9 && i !== 19 && i !== 20 ? (
                                        <TextField
                                          className={`${classes.outlineInputBorder} ${classes.tableTextField}`}
                                          value={tableRows.blueTees[i]}
                                          onChange={(e) => {
                                            onChangeBlueTextParValue(e, i);
                                          }}
                                          name="par_value"
                                          type="number"
                                        />
                                      ) : (
                                        <Typography variant="body2">
                                          {tableRows?.blueTees[i]}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Button
                                    aria-describedby={poperWId}
                                    type="button"
                                    onClick={handleClickW}
                                    sx={{
                                      backgroundColor: "White",
                                      color: "Black",
                                    }}
                                    className={classes.blueTeesBtn}
                                  >
                                    White
                                  </Button>
                                  <Popper
                                    id={poperWId}
                                    open={poperWOpen}
                                    anchorEl={w_anchorEl}
                                    sx={{
                                      borderRadius: "5px",
                                      border:
                                        "2px sollid rgba(0 0 0,0.4) !important",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        padding: "14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          // fontSize={10}
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "8px !important",
                                          }}
                                        >
                                          Course Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "5px 5px 5px 4px !important",
                                          }}
                                          onChange={onChangeWhiteCourseRating}
                                          value={tableRows?.w_courseRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        padding:
                                          "1px 14px 14px 14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          // fontSize={10}
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "5px !important",
                                          }}
                                        >
                                          Slope Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "8px 0px 0px 16px !important",
                                          }}
                                          onChange={onChangeWhiteSlopeRating}
                                          value={tableRows.w_slopeRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                  </Popper>
                                </TableCell>
                                {tableRows.holes.map((item, i) => {
                                  return (
                                    <TableCell>
                                      {i !== 9 && i !== 19 && i !== 20 ? (
                                        <TextField
                                          className={`${classes.outlineInputBorder} ${classes.tableTextField}`}
                                          value={tableRows.whiteTees[i]}
                                          onChange={(e) => {
                                            onChangeWhiteTextParValue(e, i);
                                          }}
                                          name="par_value"
                                          type="number"
                                        />
                                      ) : (
                                        <Typography variant="body2">
                                          {tableRows?.whiteTees[i]}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Button
                                    aria-describedby={poperYId}
                                    type="button"
                                    onClick={handleClickY}
                                    sx={{
                                      backgroundColor: "Yellow",
                                      color: "Black",
                                    }}
                                    className={classes.blueTeesBtn}
                                  >
                                    Yellow
                                  </Button>
                                  <Popper
                                    id={poperYId}
                                    open={poperYOpen}
                                    anchorEl={y_anchorEl}
                                    sx={{
                                      borderRadius: "5px",
                                      border:
                                        "2px sollid rgba(0 0 0,0.4) !important",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        padding: "14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          // fontSize={10}
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "8px !important",
                                          }}
                                        >
                                          Course Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "5px 5px 5px 4px !important",
                                          }}
                                          onChange={onChangeYellowCourseRating}
                                          value={tableRows.y_courseRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        padding:
                                          "1px 14px 14px 14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          // fontSize={10}
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "5px !important",
                                          }}
                                        >
                                          Slope Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "8px 0px 0px 16px !important",
                                          }}
                                          onChange={onChangeYellowSlopeRating}
                                          value={tableRows.y_slopeRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                  </Popper>
                                </TableCell>
                                {tableRows.holes.map((item, i) => {
                                  return (
                                    <TableCell>
                                      {i !== 9 && i !== 19 && i !== 20 ? (
                                        <TextField
                                          className={`${classes.outlineInputBorder} ${classes.tableTextField}`}
                                          value={tableRows.yellowTees[i]}
                                          onChange={(e) => {
                                            onChangeYellowTextParValue(e, i);
                                          }}
                                          name="par_value"
                                          type="number"
                                        />
                                      ) : (
                                        <Typography variant="body2">
                                          {tableRows?.yellowTees[i]}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <Button
                                    aria-describedby={poperBkId}
                                    type="button"
                                    onClick={handleClickBk}
                                    sx={{
                                      backgroundColor: "Black",
                                      color: "White",
                                    }}
                                    className={classes.blueTeesBtn}
                                  >
                                    Black
                                  </Button>
                                  <Popper
                                    id={poperBkId}
                                    open={poperBkOpen}
                                    anchorEl={bk_anchorEl}
                                    sx={{
                                      borderRadius: "5px",
                                      border:
                                        "2px sollid rgba(0 0 0,0.4) !important",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        padding: "14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "8px !important",
                                          }}
                                        >
                                          Course Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "5px 5px 5px 4px !important",
                                          }}
                                          onChange={onChangeBlackCourseRating}
                                          value={tableRows.bk_courseRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                    <Box
                                      sx={{
                                        padding:
                                          "1px 14px 14px 14px !important",
                                        backgroundColor: "white",
                                        color: "black",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          backgroundColor: "#F2F2F2 !important",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          color="black"
                                          sx={{
                                            display: "inline-block",
                                            px: 2,
                                            marginTop: "5px !important",
                                          }}
                                        >
                                          Slope Rating
                                        </Typography>
                                        <TextField
                                          sx={{
                                            width: "45px",
                                            margin:
                                              "8px 0px 0px 16px !important",
                                          }}
                                          onChange={onChangeBlackSlopeRating}
                                          value={tableRows.bk_slopeRating}
                                          className={classes.outlineInputBorder}
                                        />
                                      </Box>
                                    </Box>
                                  </Popper>
                                </TableCell>
                                {tableRows.holes.map((item, i) => {
                                  return (
                                    <TableCell>
                                      {i !== 9 && i !== 19 && i !== 20 ? (
                                        <TextField
                                          className={`${classes.outlineInputBorder} ${classes.tableTextField}`}
                                          value={tableRows.blackTees[i]}
                                          onChange={(e) => {
                                            onChangeBlackTextParValue(e, i);
                                          }}
                                          name="par_value"
                                          type="number"
                                        />
                                      ) : (
                                        <Typography variant="body2">
                                          {tableRows?.blackTees[i]}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>Index</TableCell>
                                {tableRows.holes.map((item, i) => {
                                  return (
                                    <TableCell>
                                      {i !== 9 && i !== 19 && i !== 20 ? (
                                        <TextField
                                          className={`${classes.outlineInputBorder} ${classes.tableTextField}`}
                                          value={tableRows.indexes[i]}
                                          onChange={(e) => {
                                            onChangeIndexesValue(e, i);
                                          }}
                                          name="par_value"
                                          type="number"
                                        />
                                      ) : (
                                        <>
                                          <Typography variant="body2">
                                            {/* {tableRows?.indexes[i]} */}
                                          </Typography>
                                        </>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                              <TableRow>
                                <TableCell>Par</TableCell>
                                {tableRows.holes.map((item, i) => {
                                  return (
                                    <TableCell>
                                      {i !== 9 && i !== 19 && i !== 20 ? (
                                        <TextField
                                          className={`${classes.outlineInputBorder} ${classes.tableTextField}`}
                                          value={tableRows.pars[i]}
                                          onChange={(e) => {
                                            onChangeTextParValue(e, i);
                                          }}
                                          name="par_value"
                                          type="number"
                                        />
                                      ) : (
                                        <Typography variant="body2">
                                          {tableRows?.pars[i]}
                                        </Typography>
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>

                    <div style={{ marginTop: "10px", marginLeft: "10px" }}>
                      <p style={{ fontSize: "14px" }}>Front 9 = Front 9</p>
                      <p style={{ fontSize: "14px", marginTop: "-10px" }}>
                        Back 9 = Back 9
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </TabPanel>
            </Grid>
          </Grid>

          {/* {modal content} */}
          <MainModal
            show={open}
            closeModal={closeModal}
            modalHeadTitle="Create Course"
            btnLeftTitle="Back"
            btnRightTitle="Save"
            btnCloseModal={() => closeModal()}
            leftVariant="contained"
            sx={{ display: "flex", alignSelf: "flex-end" }}
            width="900px"
          >
            <Grid container>
              <Grid item xs={12} mb={2}>
                <Stack spacing={1}>
                  <Grid container xs={12}>
                    <InputLabel shrink className={classes.inputLabel}>
                      Name
                    </InputLabel>
                    <Grid item container alignItems={"center"}>
                      <Grid item xs={0.55}>
                        <AccountBoxRoundedIcon
                          color="primary"
                          size="medium"
                          sx={{
                            fontSize: "47px !important",
                            alignItems: "center",
                            marginBottom: "5px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={11.45}>
                        <TextField
                          required
                          placeholder="Karachi Golf Club"
                          className={classes.outlineInputBorder}
                          fullWidth
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <InputLabel shrink className={classes.inputLabel}>
                    Address
                  </InputLabel>

                  <TextField
                    required
                    placeholder="Karachi"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Latitude
                  </InputLabel>
                  <TextField
                    required
                    placeholder="24.8871"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Longitude
                  </InputLabel>
                  <TextField
                    // sx={{ width: "350px" }}
                    required
                    placeholder="67.1061"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Course Rating
                  </InputLabel>
                  <TextField
                    required
                    placeholder="71.00"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Slope Rating
                  </InputLabel>
                  <TextField
                    required
                    placeholder="126.00"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Front 9
                  </InputLabel>
                  <TextField
                    required
                    placeholder="Front 9 Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Back 9
                  </InputLabel>
                  <TextField
                    required
                    placeholder="Back 9 Name"
                    className={classes.outlineInputBorder}
                    fullWidth
                    variant="outlined"
                  />
                  <InputLabel shrink className={classes.inputLabel}>
                    Status
                  </InputLabel>
                  <Select
                    variant="outlined"
                    value={status}
                    className={classes.outlineInputBorder}
                    name="status"
                    fullWidth
                    label="."
                    placeholder="Inactive"
                  >
                    {["Active", "Inactive"].map((item) => (
                      <MenuItem
                        key={item}
                        // setStatus={item.name}
                        value={item}
                        onClick={() => setStatus(item)}
                      >
                        <Grid container item>
                          <Grid item xs={10}>
                            {item}
                          </Grid>
                        </Grid>
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
              </Grid>
            </Grid>
          </MainModal>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
